import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

import { 
  checkEmailContainer, 
  checkEmailForm, 
  iconContainer, 
  mailIcon, 
  checkEmailTitle, 
  checkEmailText, 
  openEmailBtn, 
  resendEmail, 
  backToLogin, 
  infoText 
} from "../../styles/pages/CheckEmailStyles";

const CheckEmail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || "your email";

  return (
    <div className={checkEmailContainer}>
      <div className={checkEmailForm}>
        {/* Mail Icon */}
        <div className={iconContainer}>
          <Mail className={mailIcon} />
        </div>

        {/* Heading */}
        <h1 className={checkEmailTitle}>Check your email</h1>
        <p className={checkEmailText}>
          We sent a password reset link to <strong>{email}</strong>
        </p>

        {/* Open Email Button */}
        <button
          className={openEmailBtn}
          onClick={() => window.open("https://mail.google.com/", "_blank")}
        >
          Open email app
        </button>

        {/* Resend Email & Back to Login */}
        <p className={infoText}>
          Didn't receive the email?{" "}
          <Link to="/forgot-password" className={resendEmail}>
            Click to resend
          </Link>
        </p>
        <p className={backToLogin} onClick={() => navigate("/signin")}>
          ← Back to log in
        </p>
      </div>
    </div>
  );
};

export default CheckEmail;